@if (!isEmpty) {
  <div class="week-days mr-3 mt-1">
    @if (!isView) {
      <div class="fs-12 title">Available Days</div>
    }
    <div class="d-flex align-items-center">
      @if (isView) {
        <div class="fs-12 title mr-4">Available Days</div>
      }
      <div class="days d-flex align-items-center"
        [ngClass]="{'disabled':isDisabled}" #weekDays>
        <div class="week-day cursor-pointer" id="0">MON</div>
        <div class="week-day cursor-pointer" id="1">TUE</div>
        <div class="week-day cursor-pointer" id="2">WED</div>
        <div class="week-day cursor-pointer" id="3">THU</div>
        <div class="week-day cursor-pointer" id="4">FRI</div>
        <div class="week-day cursor-pointer" id="5">SAT</div>
        <div class="week-day cursor-pointer" id="6">SUN</div>
      </div>
    </div>
  </div>
}

